





































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '@/lib/util';
import AbpBase from '@/lib/abpbase';
import * as proxy from '@/lib/service-proxies/service-proxies';
import AppConsts from '@/lib/appconst';
import PagedFilterAndSortedRequest from '@/store/entities/page-request';
import pagelist from '@/components/pagelistcomponent';
@Component({
  components: {}
})
export default class suppliermanage extends pagelist {
    get prox() {
    return new proxy.FinancialStatisticsServiceProxy();
  }
  input :proxy.ChannelDayBillPageInputDto = new proxy.ChannelDayBillPageInputDto();
  createrange = [];
  PayChannels=[];
  columns = [
    {
      type: 'selection',
      width: 60,
      align: 'center'
    },
    {
      title: '通道',
      key: 'name'
    },
    {
      title:'总跑',
      key:'money'
    },
    {
      title: '通道实到金额',
      key: 'payMoney'
    },
    {
      title: '通道服务费',
      key: 'commission'
    }
    ,
    {
      title: '成功笔数',
      key: 'orderNum'
    },
    {
        title:'补单数',
        key:'budanNum'
    },
    {
        title:'补单金额',
        key:'budanMoney'
    }
    
  ];
  fetchDataList(
    request: PagedFilterAndSortedRequest,
    pageNumber: number,
    finishedCallback: Function
  ): void {
    this.input.skipCount = request.skipCount;
    this.input.maxResultCount = request.maxResultCount;
    this.input.sorting = request.sorting;
    this.input.createStartTime = this.createrange[0];
    this.input.createEndTime = this.createrange[1];
    this.prox.queryChannelList(this.input).then(x => {
      this.dataList = x;
      this.showPaging(x);
    });
  }
  getpage() {
    this.OnInit();
  }
  async created() {
    this.createrange = [
      new Date(new Date(new Date().toLocaleDateString()).getTime()),
      new Date(new Date(new Date().toLocaleDateString()).getTime() + 86400000),
    ];
    let req = new proxy.ChannelSimpleInputDto();
    new proxy.ChannelServiceProxy().queryAllList(req).then((x) => {
      this.PayChannels = x;
    });
    this.getpage();
  }
}
